import useToastConfirmation from "../../components/common/toasts/useToastConfirmation";
import { useToast } from "../../components/common/toasts/ToastContext";
import ErrorToast from "../../components/common/toasts/ErrorToast";
import React from "react";
import { Link } from "react-router-dom";
import { premiumPaths } from "./navigation";
import { premiumRequest } from "../../services/Premium";

import usePremiumResource from "./hooks/usePremiumResource";
import useAsyncAction from "./hooks/useAsyncAction";

export default function CompanyMembers({ company, token }) {
  const { notify } = useToast();
  const { confirm } = useToastConfirmation(company.id);
  const url = `/organizations/${company.id}/members`;
  const resource = usePremiumResource(token, url);
  const { busy: saving, error: saveError, run } = useAsyncAction();
  const members = resource.data?.members || [];
  const busy = saving || resource.loading || !resource.data;
  const error = resource.error || saveError;
  const remove = (member) =>
    run(async (isActive) => {
      if (!resource.data) return;
      if (
        !(await confirm(`Odebrać dostęp użytkownikowi ${member.name}?`, {
          acceptLabel: "Odbierz dostęp",
        })) ||
        !isActive()
      )
        return;
      const result = await premiumRequest(token, url, {
        method: "PUT",
        data: { userId: member.userId, remove: true },
      });
      if (isActive()) {
        resource.replace(result);
        notify("Odebrano dostęp użytkownika do firmy.");
      }
    });
  return (
    <section className="card premium-panel">
      <div className="premium-toolbar">
        <h2>Użytkownicy firmy</h2>
        <Link
          className="btn btn-primary"
          to={premiumPaths.newMember(company.id)}
        >
          Dodaj użytkownika
        </Link>
      </div>
      <p>
        Pracownicy mają wspólną historię świadectw tej firmy. Dostęp nadajesz
        istniejącym, aktywnym użytkownikom eCO.
      </p>
      <ErrorToast message={error} />
      {resource.loading && <p role="status">Ładowanie danych…</p>}
      {resource.error && (
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={resource.reload}
        >
          Ponów odczyt
        </button>
      )}
      {resource.data && !members.length && (
        <p>Nie dodano jeszcze użytkowników.</p>
      )}
      <ul className="premium-files">
        {members.map((member) => (
          <li key={member.userId}>
            <span>
              {member.name}
              {member.active === false && " (konto nieaktywne)"}
              <small className="d-block">
                {member.manageDictionaries
                  ? "Świadectwa i edycja słowników"
                  : "Świadectwa i podgląd słowników"}
              </small>
            </span>
            {member.active !== false && (
              <Link
                className="btn btn-outline-primary"
                to={premiumPaths.editMember(company.id, member.userId)}
              >
                Edytuj
              </Link>
            )}
            <button
              className="btn btn-outline-danger"
              disabled={busy}
              onClick={() => remove(member)}
            >
              Odbierz dostęp
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
